import { meetingBodyJoinDimensions } from './shared-dimensions.js';
import { seatApplicationWorkflowStepTypeValueLabels, seatTermApplicationStatusValueLabels, seatTermStatusValueLabels, } from './value-labels.js';
/**
 * Combination data source: Applicants x Workflow Steps.
 * Tracks each application through workflow steps, showing where applicants are in the review
 * process with pipeline duration and current step details.
 */
export const applicantPipelineCube = {
    category: 'Applications',
    description: 'Track each application through workflow steps, including pipeline duration and current step details.',
    label: 'Applicant Pipeline & Status',
    requiredModule: 'hasTenure',
    measures: {
        'applicant_pipeline.count': { label: 'Count', type: 'number' },
    },
    dimensions: {
        // Application
        'applicant_pipeline.status': {
            label: 'Application Status',
            type: 'string',
            valueLabels: seatTermApplicationStatusValueLabels,
        },
        // Applicant
        'seat_applications.days_in_pipeline': { label: 'Days In Pipeline', type: 'number' },
        'seat_applications.email': { label: 'Applicant Email', type: 'string' },
        'seat_applications.first_name': { label: 'Applicant First Name', type: 'string' },
        'seat_applications.last_name': { label: 'Applicant Last Name', type: 'string' },
        // Current Workflow Step
        'seat_application_workflow_steps.name': { label: 'Current Step', type: 'string' },
        'seat_application_workflow_steps.order': { label: 'Step Order', type: 'number' },
        'seat_application_workflow_steps.type': {
            label: 'Step Type',
            type: 'string',
            valueLabels: seatApplicationWorkflowStepTypeValueLabels,
        },
        // Workflow
        'seat_application_workflows.name': { label: 'Workflow', type: 'string' },
        // Template
        'seat_application_templates.name': { label: 'Application Template', type: 'string' },
        ...meetingBodyJoinDimensions,
        // Seat
        'meeting_body_seats.number': { label: 'Seat Number', type: 'number' },
        'meeting_body_seats.title': { label: 'Seat Title', type: 'string' },
        // Term
        'meeting_body_seat_terms.number': { label: 'Term Number', type: 'number' },
        'meeting_body_seat_terms.status': {
            label: 'Term Status',
            type: 'string',
            valueLabels: seatTermStatusValueLabels,
        },
        // Applicant contact (via phone join)
        'phones.number': { label: 'Applicant Phone Number', type: 'string' },
    },
    timeDimensions: {
        'applicant_pipeline.created_at': { label: 'Application Created At', type: 'date' },
        'applicant_pipeline.updated_at': { label: 'Application Updated At', type: 'date' },
        'meeting_body_seat_terms.start_date': { label: 'Term Start Date', type: 'date' },
        'meeting_body_seat_terms.end_date': { label: 'Term End Date', type: 'date' },
        'seat_applications.submitted_at': { label: 'Submitted At', type: 'date' },
    },
};
